
import createEditDealerRedux from 'Modules/dealers/views/.components/createEditDealer/redux/reducer';
import dealerOverviewRedux from 'Modules/dealers/views/overview/redux/reducer';

// slice
import createEditBillingAccountRedux from 'Modules/dealers/views/.components/createEditBillingAccount/redux/slice';
import deleteBillingAccountRedux from '../../views/.components/deleteBillingAccount/redux/slice';
import assignBillingAccountRedux from '../../views/.components/assignBillingAccount/redux/slice';
import dealerAlertLogsTabRedux from '../../views/.components/dealerAlertLogsTab/redux/slice';
import resendDealerAlertLogRedux from '../../views/.components/resendDealerAlertLog/redux/slice';
import webHooksTabRedux from '../../views/.components/webHooksTab/redux/slice';
import createEditWebHookRedux from '../../views/.components/createEditWebHook/redux/slice';
import deleteWebHookRedux from '../../views/.components/deleteWebHook/redux/slice';

//export redux objects
export default {
	createEditDealerRedux,
	dealerOverviewRedux,
	createEditBillingAccountRedux,
	deleteBillingAccountRedux,
	assignBillingAccountRedux,
	dealerAlertLogsTabRedux,
	resendDealerAlertLogRedux,
	webHooksTabRedux,
	createEditWebHookRedux,
	deleteWebHookRedux
};